<ca-clickable-link
  [innerHtml]="
    'Analysis::GenAI.Project.ReadyNotificationMessage' | abpLocalization : payloadData?.name
  "
  (linkClicked)="onClick()">
</ca-clickable-link>
